import { render, staticRenderFns } from "./add-container-groups.vue?vue&type=template&id=1e5a86a8"
import script from "./add-container-groups.vue?vue&type=script&lang=js"
export * from "./add-container-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports